



































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import PersonAvatar from '@/components/global/avatar.vue'

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'AvatarList',

  components: {
    PersonAvatar,
  },

  props: {
    people: {
      type: Array as () => IPersonBase[],
      required: true,
    },
    maxNumAvatars: {
      type: Number,
      default: 4,
    },
    size: {
      type: Number,
      default: 24,
    },
  },

  data() {
    return {
      maxNumAvatarsTooltip: 7,
      isAvatarTooltip: false,
    }
  },

  computed: {
    avatarsToDisplay(): IPersonBase[] {
      const arrayToDisplay = [...this.people]
      return arrayToDisplay.splice(0, this.maxNumAvatars)
    },
    remainingAvatars(): Number {
      return this.people.length - this.maxNumAvatars
    },
    listRemainingAvatars(): IPersonBase[] {
      const arrayToDisplay = [...this.people].splice(this.maxNumAvatars)
      return arrayToDisplay.splice(0, this.maxNumAvatarsTooltip)
    },
    remainingTooltipAvatars(): Number {
      return (
        [...this.people].splice(this.maxNumAvatars).length -
        this.maxNumAvatarsTooltip
      )
    },
  },
})
